import { Component, Inject, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AtivoService } from "app/auxiliares/services/ativo-service";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { ClienteModel } from "app/clientes/models/cliente.model";
import { ClienteService } from "app/clientes/services/cliente.service";
import { map, Observable } from "rxjs";
import { BaseComponent } from "../../base-module/base-component/base.component";
import { ImportacaoArquivoService } from "../services/importacao-arquivo.service";

export interface DialogData {
    id: number;
}

@Component({
    selector: "dialog-filtrar-custodia",
    templateUrl: "./filtrar-custodia.component.html",
    styleUrls: ["./filtrar-custodia.component.scss"]
})
export class FiltrarCustodiaComponent extends BaseComponent {
    primeiroDia = this._utilitesService.primeiroDiaMes();
    ultimoDia = this._utilitesService.ultimoDiaMes();

    cliente = new FormControl("");
    ativo = new FormControl("");
    data_operacao_inicio = new FormControl(this.primeiroDia);
    data_operacao_fim = new FormControl(this.ultimoDia);
    assessor_id = new FormControl("");
    arquivo_id = new FormControl("");

    paramsStatus: any = {
        finalizada: ""
    };
    loadingSpinner: boolean = false;
    loadingSpinnerStatus: boolean = false;
    loadingSpinnerAssessor: boolean = false;
    loadingSpinnerAtivos: boolean = false;
    loadingSpinnerArquivos: boolean = false;
    filteredOptions!: Observable<ClienteModel[]>;
    listStatus: any[] = [];
    listAssessor: any[] = [];
    listAtivos: any[] = [];
    listArquivos: any[] = [];
    filteredOptionsAtivo!: Observable<any[]>;

    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;
    @ViewChild(FiltrarCustodiaComponent, { static: false }) table!: FiltrarCustodiaComponent;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<FiltrarCustodiaComponent>,
        private _clienteService: ClienteService,
        private _utilitesService: UtilitesService,
        private _ativoService: AtivoService,
        private _importacaoService: ImportacaoArquivoService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {

        super(dialog, snackBar);

        this.cliente.valueChanges.subscribe(
            query => {
                if (typeof query === "string" || typeof query === "number") {
                    this.loadingSpinner = true;
                    this.params.search = query;
                    this.filteredOptions = this._clienteService.search(this.params).pipe(map(response => response.data));
                }
            }
        );

        this.ativo.valueChanges.subscribe(
            query => {
                if (typeof query === "string") {
                    this.loadingSpinnerAtivos = true;
                    this.params.search = query;
                    this.params.tipo = "NORMAL";
                    this.filteredOptionsAtivo = this._ativoService.search(this.params);
                }
            }
        );

        this.getAllArquivos();
    }

    displayFn(cliente: any): string {
        if (cliente) {
            return cliente.nome;
        }
        return "";
    }

    getCliente(cliente: any): void {
        this.loadingSpinner = false;
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    filtrar(): void {


        let inic = null;
        if (this.data_operacao_inicio.value != null) {
            inic = this._utilitesService.formatDateToString(this.data_operacao_inicio.value ?? new Date());
        }

        let fim = null;
        if (this.data_operacao_fim.value != null) {
            fim = this._utilitesService.formatDateToString(this.data_operacao_fim.value ?? new Date());
        }

        this.dialogRef.close({
            "cliente": this.cliente.value,
            "data_operacao_inicio": inic,
            "data_operacao_fim": fim,
            "ativo": this.ativo.value,
            "importacao_id": this.arquivo_id.value,
        });
    }

    displayFnAtivo(ativo: any): string {
        if (ativo) {
            return ativo.sigla;
        }
        return "";
    }


    getAtivo(ativo: any): void {
        this.loadingSpinnerAtivos = false;
    }


    getAtivos(): void {
        this.loadingSpinnerAtivos = true;
        this._ativoService.getAll({ no_paginate: true })
            .subscribe(
                resquest => {
                    this.listAtivos = resquest.data;
                },
                error => {
                    this.loadingSpinnerAtivos = false;
                },
                () => {
                    this.loadingSpinnerAtivos = false;
                    console.log("complete");
                }
            );
    }


    getAllArquivos(): void {
        this.loadingSpinnerArquivos = true;
        this._importacaoService.getAll({ no_paginate: true })
            .subscribe(
                resquest => {
                    this.listArquivos = resquest.data;
                },
                error => {
                    this.loadingSpinnerArquivos = false;
                },
                () => {
                    this.loadingSpinnerArquivos = false;
                    console.log("complete");
                }
            );
    }



}